import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentDevolutionUpdateAction from './equipmentDevolutionUpdate.action.json' with { type: 'json' }
import equipmentDevolutionObject from '../equipmentDevolutionObject'

const equipmentDevolutionUpdateDefinition = defineAction({
  ...equipmentDevolutionUpdateAction,

  input: equipmentDevolutionObject
    .pick({
      id: true,
      observation: true,
      devolutionDate: true,
      citizenId: true,
    })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default equipmentDevolutionUpdateDefinition
